import { useAppSelector } from '@redux/hooks';
import { Wrapper } from '@sharedComponents/Wrapper';
import { PopupRecordPhone } from './PopupRecordPhone';
import { Grid } from '@ui-kit/Grid';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';
import IconRectangle from './rectangle.svg';

import styles from './PhoneBlock.module.scss';

export const PhoneBlock = (): JSX.Element => {
  const { PHONE, FEDERAL_PHONE } = useAppSelector(state => state.header.data.region);
  return (
    <Grid row at gap={'6px'} className={styles.Container} data-testid="header-phone-block">
      <span className={'first-local-phone'}>{PHONE || FEDERAL_PHONE}</span>
      <IconRectangle width={5.66} height={3} />
      <ErrorBoundaryComponent>
        <Wrapper className={styles.WrapperPopup}>
          <PopupRecordPhone />
        </Wrapper>
      </ErrorBoundaryComponent>
    </Grid>
  );
};
